import { Badge } from '@/components/ui/badge';
import { JsonBlock } from '@/components/runs/JsonBlock';
import { Section } from '@/components/runs/Section';
import type { FailureDetail } from '@/types/run';

export function FailureSection({ failure }: { failure: FailureDetail }) {
  return (
    <Section label="Failure" tone="failure">
      <div className="space-y-2">
        <div className="flex flex-wrap items-center gap-2 text-xs">
          {failure.type && <Badge tone="failure">{failure.type}</Badge>}
          {failure.message && <span className="font-mono text-red-800 dark:text-red-200">{failure.message}</span>}
        </div>
        {failure.stack_trace && (
          <details className="text-xs">
            <summary className="cursor-pointer text-muted-foreground hover:text-foreground">
              Stack trace
            </summary>
            <pre className="mt-1 overflow-x-auto rounded-md bg-muted/60 p-2 font-mono text-[11px] leading-relaxed">
              {failure.stack_trace}
            </pre>
          </details>
        )}
        {failure.cause && (
          <details className="text-xs">
            <summary className="cursor-pointer text-muted-foreground hover:text-foreground">
              Caused by
            </summary>
            <JsonBlock value={failure.cause} className="mt-1" />
          </details>
        )}
      </div>
    </Section>
  );
}
